// ResponsiveNotifications.jsx — aiguille la route /notifications :
//   ≤ 768px  → écran plein écran mobile (MobileNotificationsPage)
//   > 768px  → page desktop existante (NotificationsList)
// Même patron que ResponsiveGestionProduit.jsx.
import React from "react";
import useIsMobile from "../hooks/useIsMobile";
import MobileNotificationsPage from "../mobile/notifications/MobileNotificationsPage";
import NotificationsList from "./NotificationsList.tsx";

export default function ResponsiveNotifications() {
  return useIsMobile() ? <MobileNotificationsPage /> : <NotificationsList />;
}
